import React, { useState, useEffect, useRef } from 'react';
import { useSelector, useDispatch } from "react-redux";
import Modal from 'react-modal';
import { loadOrderInspection, loadInspectionStatus } from '../../actions';
import { toastr } from 'react-redux-toastr';
import { getConfig } from "../../utils/helpers";

export default function InspectionModal({ mpId, itemData, isOpen, onClose }) {

    const styles = {
        customStyles: {
            overlay: {
                zIndex: 99,
                backgroundColor: 'rgba(0, 0, 0, .6)',
            },
        },
        container: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'stretch',
            alignContent: 'space-around',
            flexWrap: 'wrap',
            padding: '0 .15rem',
        },
        quoteContainer: {
            width: '100%',
            padding: '1rem .5rem',
        },
        header: {
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            textAlign: 'center',
            //width: '100%',
        },
        divider: {
            borderColor: '#E5E5E5',
            width: '100%',
            alignSelf: 'center',
            marginTop: 15,
            marginBottom: 10,
        },
        textContainer: {
            textAlign: 'center',
            padding: '0 5px',
          },
        buttons: {
            display: 'flex',
            justifyItems: 'center',
            flexDirection: 'row',
            alignSelf: 'flex-end',
            gap: '1em'
        }
    };

    const fields = [
      { label: 'Location Name',  name: 'name'          , required: true  },
      { label: 'Street',         name: 'street'        , required: true  },
      { label: 'Street 2',       name: 'street2'       , required: false },
      { label: 'City',           name: 'city'          , required: true  },
      { label: 'State',          name: 'state'         , required: true  },
      { label: 'Zip Code',       name: 'zip'           , required: true  },
      { label: 'First Name',     name: 'firstName'     , required: true  },
      { label: 'Last Name',      name: 'lastName'      , required: true  },
      { label: 'Email',          name: 'email'         , required: true  },
      { label: 'Phone',          name: 'businessPhone' , required: true  },
      { label: 'Comments',       name: 'comments'      , required: false, width: 2},
    ];

    const [values, setValues] = useState(
      fields.reduce((acc, f) => ({ ...acc, [f.name]: '' }), {})
    );
  
    const handleChange = e => {
      const { name, value } = e.target;
      setValues(v => ({ ...v, [name]: value }));
    };
  
    const allRequiredFilled = fields
      .filter(f => f.required)
      .every(f => values[f.name].trim() !== '');

    const [isModalOpen, setModalOpen] = useState(isOpen);
    const [isAgreementChecked, setIsAgreementChecked] = useState(false);
    const agreementRef = useRef(null);
    const dispatch = useDispatch();

    const {inspectionStatus} = useSelector(reduxState => {        
      const {inspectionStatus} = reduxState.entities;
      return {inspectionStatus}
  });

    useEffect(() => {
      const { itemId } = itemData;
      if (!itemId) {
          return;
      } 
      dispatch(loadInspectionStatus(mpId, itemId));
  }, [itemData, dispatch,])

    useEffect(() => {
        setModalOpen(isOpen);
    }, [isOpen]);

    function handleClose() {
        setModalOpen(false);
        onClose();
    }

    function handleSubmit() {
        const { itemId } = itemData;
        dispatch(loadOrderInspection(mpId, itemId, values, getConfig('inspectionProviderOverride') ?? 'Aim'))
        .then(res => {
          onClose();
          toastr.success(
            'Success!',
            'Your inspection order was submitted successfully',
            { position: 'top-center',
              timeOut: 2500,
              onHideComplete: ()=>onClose()
            }
          );
        })
        .catch(err => {
          toastr.error(
            'Inspection order error',
            'An error occurred when ordering an inspection, please try again later.',
            { position: 'top-center', 
              timeout: 3000,
              onHideComplete: ()=>onClose()
            }
          );
          console.error(err);
        });
    }

    function renderHeader() {
        return (
            <div style={{ ...styles.header, alignSelf: 'stretch' }}>
                {/* Form Title */}
                <div style={{ fontSize: 24, color: '#535768' }}>
                    <div>
                        <span className="fa fa-clipboard" />
                        <span style={{ marginLeft: 10 }}>
                        {
                          {
                          ['None']:
                          'Order Inspection',
                          ['Processing']:
                          'Inspection Order Processing',
                          ['Scheduled']:
                          'Inspection Scheduled',
                          ['Canceled']:
                          'Inspection Cancelled',
                          ['Pending']:
                          'Inspection Pending',
                          ['Complete']:
                          'Inspection Complete',
                        }[inspectionStatus?.status]
                      }
                        </span>
                    </div>
                </div>
                {/* Close Modal */}
                <button
                    type="button"
                    className="close"
                    data-dismiss="modal"
                    aria-label="Close"
                    onClick={() => handleClose()}
                >
                    <span aria-hidden="true">×</span>
                </button>
            </div>
        );
    }

    function renderOrderForm() {
        return (
            <>
            {renderForm()}
            {renderAgree()}
            <hr style={styles.divider} />
            {renderFormFooter()}
          </>
        );
    }

    function renderForm() {
      return (
        <div>
          {fields.map((field, index) => {
            
            const isEmptyRequired = field.required && !values[field.name].trim();
            const width = (field.width ?? 1) * 6;
            return (
            <div key={index} className={`form-group col-md-${width} col-sm-${width}`} style={{}}>
                <label className="control-label" htmlFor="name">
                    {field.label}
                </label>

                <input
                    id={field.name}
                    name={field.name}
                    value={values[field.name]}
                    onChange={handleChange}
                    className="form-control input-sm"
                    style={{
                        backgroundColor: '#EFEFEF',
                        border: isEmptyRequired
                        ? '1px solid red'
                        : undefined,
                    }}
                    type="text"
                />
            </div>
          )})}
        </div>
      );
    }

    function renderAgree() {

        return (
          <div style={{
            alignItems: 'center',
            alignContent: 'center',
            display: 'flex',
            flexDirection: 'row',
            gap: '5px',
            justifyContent: 'space-around',
            justifyItems: 'center',
            width: 'auto',
            margin: '.25rem .5rem'
          }
          }>
            <label style={{ verticalAlign: 'center', margin: '0 auto', fontSize: '1.15em', fontStyle: 'italic' }} >
              I have transported and taken possession of this vehicle.
            </label>
            <input
              aria-label={'agree'}
              defaultChecked={false}
              onChange={() => { setIsAgreementChecked(agreementRef.current.checked) }}
              type={'checkbox'}
              style={{ verticalAlign: 'middle', margin: '0 auto', width: '1.25em', height: '1.25em' }}
              ref={agreementRef}
            />
          </div>
        )
      }

    function renderFormFooter(){
        const isSubmitDisabled = !isAgreementChecked || !allRequiredFilled;
        return (
            <div style={styles.buttons}>
            {/* 'Cancel' button */}
            <button
              className="btn btn-primary button-cancel"
              style={{
                minWidth: 100,
              }}
              type="button"
              data-dismiss="modal"
              onClick={() => { onClose() }}
            >
              Cancel
            </button>
    
            {/* 'Submit' button */}
            <button
              className="btn btn-primary button-action"
              style={{
                opacity: isSubmitDisabled ? 0.25 : 1,
                minWidth: 120,
              }}
              disabled={isSubmitDisabled}
              type="button"
              onClick={() => handleSubmit()}
            >
              Order Inspection
            </button>
          </div>
        );
    }

    function renderInspectionText(text) {
        return (
            <div style={styles.textContainer}>
                {text}
            </div>
        );
    }

    function renderInspectionComplete(url) {
      return (
          <div style={styles.textContainer}>
              Your inspection is complete. Click <a href={url} target="_blank">here</a> to view the inspection.
          </div>
      );
  }

    return (
        <Modal
            isOpen={isModalOpen}
            className={'marketplace-reusable__modal-content'}
            overlayClassName={'marketplace-reusable__modal-overlay'}
        >
            <div style={styles.container}>
                {renderHeader()}
                <hr style={styles.divider} />
                {
                    {
                        ['None']:
                        renderOrderForm(),
                        ['Processing']:
                        renderInspectionText('Your inspection order is being processed.'),
                        ['Scheduled']:
                        renderInspectionText(`Your inspection is scheduled for ${inspectionStatus.scheduledDate}`),
                        ['Canceled']:
                        renderInspectionText('Your inspection has been cancelled.'),
                        ['Pending']:
                        renderInspectionText('Your inspection is pending.'),
                        ['Complete']:
                        renderInspectionComplete(inspectionStatus?.inspectionUrl),
                    }[inspectionStatus?.status]
                }

            </div>
        </Modal>
    );
}


